export const OPEN_BACKDROP = '[BACKDROP] OPEN';
export const CLOSE_BACKDROP = '[BACKDROP] CLOSE';

export function closeBackdrop() {
  return {
    type: CLOSE_BACKDROP,
  };
}

export function openBackdrop(options) {
  return {
    type: OPEN_BACKDROP,
    options,
  };
}
